<div
  [ngClass]="containerClasses()"
  [attr.aria-label]="ariaLabel()"
  [attr.role]="ariaLabel() ? 'img' : null"
>
  <i [ngClass]="iconClasses()" aria-hidden="true"></i>
</div>
